// extracted by mini-css-extract-plugin
export default {"paper":"Paper_paper__Hbnb+","pattern":"Paper_pattern__ioG74","colorLayer":"Paper_colorLayer__3oIOB","colorLayer2":"Paper_colorLayer2__LGmqX"};